;(function (_, $) {
  $(document).ready(function(){

    // Back to Top Button Functionality
    const backToTopButton = $('#back-to-top');
    const progressCircle = $('.back-to-top-circle');

    // Show/hide button based on scroll position
    $(window).on('scroll', function() {
      const scrollTop = $(window).scrollTop();
      const docHeight = $(document).height();
      const winHeight = $(window).height();

      // Calculate scroll percentage
      const scrollPercent = scrollTop / (docHeight - winHeight);

      // Update progress circle
      if (progressCircle.length) {
        const circumference = 283; // 2*π*r where r=45
        const offset = circumference - (scrollPercent * circumference);
        progressCircle.css('stroke-dashoffset', offset);
      }

      // Show button after scrolling down 300px
      if (scrollTop > 300) {
        backToTopButton.addClass('visible');
      } else {
        backToTopButton.removeClass('visible');
      }
    });

    // Smooth scroll to top when button is clicked
    backToTopButton.on('click', function() {
      $('html, body').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  });
})(window, jQuery);
